import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {ServerAuthenticationStrategiesEnum} from './serverModel';

/*
 * Runtime type.
 */

const RApplicationCredentialsBase = t.readonly(
  t.type({
    createdAt: t.number,
  }),
);

const RNoneApplicationCredentials = t.readonly(
  t.type({
    type: t.literal(ServerAuthenticationStrategiesEnum.NONE),
  }),
);

const ROAuth2ApplicationCredentials = t.readonly(
  t.intersection([
    RApplicationCredentialsBase,
    t.type({
      type: t.literal(ServerAuthenticationStrategiesEnum.OAUTH2),
      access_token: t.string,
    }),
  ]),
);

const RBasicApplicationCredentials = t.readonly(
  t.intersection([
    RApplicationCredentialsBase,
    t.type({
      type: t.literal(ServerAuthenticationStrategiesEnum.BASIC),
      username: t.string,
      password: t.string,
    }),
  ]),
);

const RBearerApplicationCredentials = t.readonly(
  t.intersection([
    RApplicationCredentialsBase,
    t.type({
      type: t.literal(ServerAuthenticationStrategiesEnum.BEARER),
      access_token: t.string,
    }),
  ]),
);

export const RApplicationCredentials = t.union([
  RNoneApplicationCredentials,
  ROAuth2ApplicationCredentials,
  RBasicApplicationCredentials,
  RBearerApplicationCredentials,
]);

/*
 * Type.
 */

export interface NoneApplicationCredentials extends t.TypeOf<typeof RNoneApplicationCredentials> {}
// eslint-disable-next-line @typescript-eslint/naming-convention
export interface OAuth2ApplicationCredentials extends t.TypeOf<typeof ROAuth2ApplicationCredentials> {}
export interface BasicApplicationCredentials extends t.TypeOf<typeof RBasicApplicationCredentials> {}
export interface BearerApplicationCredentials extends t.TypeOf<typeof RBearerApplicationCredentials> {}
export type ApplicationCredentialsModel = t.TypeOf<typeof RApplicationCredentials>;

/*
 * IO methods.
 */

export function parseApplicationCredentials(src: any): ApplicationCredentialsModel {
  return {
    ...src,
    createdAt: src.created_at,
  };
}

/*
 * API type.
 */

export const ApiApplicationCredentials = makeApiType(
  'ApplicationCredentials',
  RApplicationCredentials,
  parseApplicationCredentials,
);
